var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('NavLinks',{attrs:{"auth":_vm.auth,"authenticated":_vm.authenticated}}),_vm._t("top"),(_vm.items.length)?_c('ul',{staticClass:"sidebar-links"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i},[_c('SidebarLink',{attrs:{"item":item}})],1)}),0):_vm._e(),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }